<template>
    <div class="container-fluid wishlist">
        <ul class="d-flex breadcrumb-list">
            <li class="breadcrumb-item"><a href="/" class="text-decoration-none">{{ window.getTranslationText("Home") }} </a></li>
            <li class="breadcrumb-item active">{{ window.getTranslationText("Wish list")}}</li>
        </ul>
        <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>
        <div v-else class="d-flex flex-column">
            <h1>{{ window.getTranslationText("Wish list")}}</h1>
            <div class="d-flex col-12 mt-4" v-if="this.items[0]">
                <CardModelComponent :size="'smaller'" :products="this.items[0]"/>
            </div>
            <div class="d-flex col-12" style="height: 42vh" v-else>
                <h1 class="col-8 mx-auto text-center"> {{ window.getTranslationText("You don't have a selected item yet. Go to the")}} <a href="/gallery" class="link-to-gallery">{{ window.getTranslationText("Gallery") }}</a> {{ window.getTranslationText("to choose a model") }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
import TheLoaderComponent from "./TheLoaderComponent.vue";
import CardModelComponent from "./CardModelComponent";

export default {
    components: {
        CardModelComponent,
        TheLoaderComponent
    },
    data: function () {
        return {
            items: [],
            lang: window.currentLang
        }
    },
    mounted() {
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
        this.getItems()

    },

    methods: {
        getItems() {
            let vm = this
            axios.get('/wishlist/items').then(function (response) {
                let data = response.data.data
                let iconCounts = document.querySelectorAll('.js-count-items')

                data.forEach(item => {
                    if (item.models.length > 0) {
                        vm.items.push(item.models)
                    }
                })

                iconCounts.forEach(count => {
                    count.textContent = localStorage.getItem('itemCount')
                })
            })
        },
        changeContent() {
            if (window.currentLang === 'ar-sa') {

            } else {

            }
        },

    }
}


</script>

<style>
@import "../../sass/front/wishlist.scss";
</style>
